import { type ChannelStats } from '../compat/tvpil';

import { getTopXWatched } from './getTopXWatched';

type CreateMostWatchedArgs = {
  mostWatched: {
    presentMostWatchedCount: number;
    presentMostWatchedPeriod: number;
  };
  watchStats: ChannelStats[] | undefined;
};

export function createMostWatched({ mostWatched, watchStats }: CreateMostWatchedArgs) {
  if (!watchStats) {
    return new Map<number, number>();
  }

  return getTopXWatched({
    watchStats,
    watchPeriod: mostWatched.presentMostWatchedPeriod,
    topX: mostWatched.presentMostWatchedCount,
  });
}
